import { Toast } from "antd-mobile";
import classNames from "classnames";
import { FC } from "react"
import styles from "./index.module.less";

interface CopyProps {
  text: string
}
const Copy: FC<CopyProps> = ({text}) => {
  const onClickCopy = () => {
    var aux = document.createElement("input"); 
    aux.setAttribute("value", text); 
    document.body.appendChild(aux); 
    aux.select();
    document.execCommand("copy"); 
    document.body.removeChild(aux);
    Toast.show({
      content: '复制成功',
      afterClose: () => {
        console.log('after')
      },
    })
  }
  return <div onClick={onClickCopy}>
    <span>{text}</span>
    <span className={classNames("iconfont icon-fuzhi", styles.copy)}></span>
  </div>
}

export default Copy